module.exports = __webpack_public_path__ + "static/media/ch4.af3c4e94.jpg";